import { apiRequest } from "./client";

export type GuideNavigateAction = {
  type: "navigate";
  label: string;
  path: string;
};

export type GuideCallAction = {
  type: "call";
  label: string;
  phone: string;
};

export type GuideEscalateAction = {
  type: "escalate";
  label: string;
};

export type GuideEmailAction = {
  type: "email";
  label: string;
  email: string;
};

export type GuideOpenUrlAction = {
  type: "open_url";
  label: string;
  url: string;
};

export type GuideShowImageAction = {
  type: "show_image";
  label: string;
  url: string;
};

export type GuideAction =
  | GuideNavigateAction
  | GuideCallAction
  | GuideEscalateAction
  | GuideEmailAction
  | GuideOpenUrlAction
  | GuideShowImageAction;

export type GuideHistoryMessage = {
  role: "user" | "assistant";
  content: string;
};

export type AiQuotaInfo = {
  allowed: boolean;
  limit: number;
  used: number;
  remaining: number;
  resetAt: string | null;
  retryAfterSec: number;
};

export type GuideWelcomeResponse = {
  welcome: string;
  suggestions: string[];
  llmEnabled: boolean;
  persona?: "visitor_guide" | "exhibitor_support";
  quota?: AiQuotaInfo | null;
};

export type GuideChatResponse = {
  reply: string;
  actions: GuideAction[];
  suggestions: string[];
  source: "llm" | "fallback" | "kb";
  model?: string;
  persona?: "visitor_guide" | "exhibitor_support";
  escalated?: boolean;
};

export const guideApi = {
  getWelcome(eventId: string, lang?: string): Promise<GuideWelcomeResponse> {
    const qs = lang ? `?lang=${lang}` : "";
    return apiRequest<GuideWelcomeResponse>(`/events/${eventId}/guide${qs}`, {
      audience: "visitor",
    });
  },

  sendMessage(
    eventId: string,
    payload: { message: string; history?: GuideHistoryMessage[]; lang?: string },
  ): Promise<GuideChatResponse> {
    return apiRequest<GuideChatResponse>(`/events/${eventId}/guide`, {
      method: "POST",
      audience: "visitor",
      body: payload,
    });
  },

  escalate(eventId: string, lang?: string, message?: string): Promise<GuideChatResponse> {
    const qs = lang ? `?lang=${lang}` : "";
    return apiRequest<GuideChatResponse>(`/events/${eventId}/guide/escalate${qs}`, {
      method: "POST",
      audience: "visitor",
      body: message ? { message } : {},
    });
  },
};
